import React from 'react';
import './CriteriaDrilldownWrapper.scss';
import BemClass from '@upsales/components/Utils/bemClass';

const CriteriaDrilldownWrapper = ({ children, className, open }) => {
	const classes = new BemClass('CriteriaDrilldownWrapper', className);
	return <tr className={classes.mod({ open }).b()}>{children}</tr>;
};
export default CriteriaDrilldownWrapper;
